import { Link } from 'react-router-dom';
import { latestComics, hotComics } from '@/mocks/comics';
import { useState } from 'react';

export default function LatestUpdates() {
  const [activeTab, setActiveTab] = useState<'latest' | 'hot'>('latest');
  const comics = activeTab === 'latest' ? latestComics : hotComics;

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between mb-8 gap-4">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">
            漫画列表
          </h2>
          <div className="flex items-center bg-background-100 rounded-full p-1">
            <button
              onClick={() => setActiveTab('latest')}
              className={`px-5 py-2 text-sm font-medium rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer ${
                activeTab === 'latest'
                  ? 'bg-primary-500 text-background-50'
                  : 'text-foreground-600 hover:text-foreground-900'
              }`}
            >
              最近更新
            </button>
            <button
              onClick={() => setActiveTab('hot')}
              className={`px-5 py-2 text-sm font-medium rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer ${
                activeTab === 'hot'
                  ? 'bg-primary-500 text-background-50'
                  : 'text-foreground-600 hover:text-foreground-900'
              }`}
            >
              人气热门
            </button>
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {comics.map((comic) => (
            <Link
              key={comic.id}
              to={`/article/${comic.slug}`}
              className="group cursor-pointer"
            >
              <div className="relative aspect-[3/4] rounded-lg overflow-hidden bg-background-100 mb-3">
                <img
                  src={comic.coverUrl}
                  alt={comic.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-400"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-2">
                  <span className="text-background-50 text-xs whitespace-nowrap">{comic.status}</span>
                </div>
                {activeTab === 'hot' && (
                  <div className="absolute top-2 right-2">
                    <span className="flex items-center gap-1 px-2 py-0.5 bg-accent-500 text-background-50 text-xs rounded-full font-medium whitespace-nowrap">
                      <i className="ri-fire-line w-3 h-3 flex items-center justify-center"></i>
                      {(comic.views / 10000).toFixed(0)}万
                    </span>
                  </div>
                )}
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1">
                {comic.title}
              </h3>
              <div className="flex items-center gap-2 mt-1 flex-wrap">
                <span className="text-xs text-foreground-500 whitespace-nowrap">{comic.author}</span>
                <span className="w-1 h-1 rounded-full bg-foreground-300 flex-shrink-0"></span>
                <span className="text-xs text-foreground-400 whitespace-nowrap">{comic.category}</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}